import "../../assets/style/SoftwareDevelopment.css"

import Topbar from "../../component/Topbar/Topbar";
import Footer from "../../component/Footer/Footer";
import checklist from "../../assets/icon/checklist.svg";

import bg from "../../assets/photo/softwareBackground.webp"
import { useTranslation } from "react-i18next";


function SoftwareDev(params) {
    const { t } = useTranslation();

    const listWeb = [
        "Custom Development",
        "Responsive Design",
        "E-commerce Integration",
        "Content Management Systems (CMS)",
        "API Integration",
        "Security",
        "Performance Optimization",
        "Maintenance & Support",
    ];

    const listMobile = [
        "iOS & Android Development",
        "Cross-Platform Solutions",
        "User-Centric Design",
        "Push Notifications",
        "In-App Purchases",
        "Offline Functionality",
        "Data Synchronization",
        "Testing & QA",
        "Deployment & Maintenance"
    ];

    return(
        <>
            <Topbar/>
        
            <section className='software'>
                <div className='mainSoftware'>
                    <img src="/photo/softwareBackground.webp" className='backgroundMainSoftware' alt="background" loading='eager' fetchPriority='high'/>
                    <div className='contentMainSoftware'>
                        <h1 className='white'>Software Development</h1>
                    </div>
                </div>
            </section>

            <section className="contentSoftware">
                <div className="width70">
                    <h1 style={{fontSize: '32px'}}>{t("softwaredev1")}</h1>
                    <p className="textNormal">{t("softwaredev2")}</p>

                    <p className="titleNormal">Web App</p>
                    <p className="textNormal">{t("softwaredev3")}</p>

                    {listWeb.map((item, index) => (
                        <div key={index} className="itemSoftware" style={{marginBottom: '8px'}}>
                            <div style={{display: 'flex'}}>
                                <img src={checklist} alt="check"/>
                            </div>
                            <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                        </div>
                    ))}

                    <p className="titleNormal">Mobile App</p>
                    <p className="textNormal">{t("softwaredev4")}</p>

                    {listMobile.map((item, index) => (
                        <div key={index} className="itemSoftware" style={{marginBottom: '8px'}}>
                            <div style={{display: 'flex'}}>
                                <img src={checklist} alt="check"/>
                            </div>
                            <p className="textNormal textAlignStart" style={{margin: '0px'}}>{item}</p>
                        </div>
                    ))}

                </div>

                <div className="cardSoftware">
                    <p className="titleHigh">{t("sidecardtitle")}</p>
                    <p className="textNormal mb64">{t("sidecardtext")}</p>
                    <div>
                        <button className="buttonBlack" onClick={() => {window.open('https://wa.me/6281703090603', '_blank')}}>{t("hpc1colaboration")}</button>
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    );
};

export default SoftwareDev;